'use client';

import { Image } from '@heroui/react';
import type { QuickFixRepairItem } from './types';

const THUMB_GRADIENT: Record<string, string> = {
  t1: 'bg-gradient-to-br from-[#8b5a3c] to-[#5a3622]',
  t2: 'bg-gradient-to-br from-[#6b6b6b] to-[#3a3a3a]',
  t3: 'bg-gradient-to-br from-[#c7a17a] to-[#6b5235]',
  t4: 'bg-gradient-to-br from-[#5a6670] to-[#2d3640]',
};

export default function CompactRepairItem({
  item,
  onDark = false,
}: {
  item: QuickFixRepairItem;
  onDark?: boolean;
}) {
  const thumbClass =
    THUMB_GRADIENT[item.thumbVariant || 't1'] ?? THUMB_GRADIENT.t1;

  return (
    <div className='flex min-w-0 items-center gap-2.5 py-0.5'>
      {item.thumbUrl ? (
        <Image
          src={item.thumbUrl}
          alt=''
          className='h-[22px] w-[22px] shrink-0 rounded object-cover'
          radius='sm'
        />
      ) : (
        <div
          className={`h-[22px] w-[22px] shrink-0 rounded ${thumbClass}`}
          aria-hidden
        />
      )}
      <span
        className={`min-w-0 flex-1 line-clamp-2 text-xs font-medium leading-snug ${
          onDark ? 'text-white/90' : 'text-foreground'
        }`}
      >
        {item.title}
      </span>
    </div>
  );
}
